export enum TrackingCategory {
  LoggedOut = 'Logged out',
}
